const win = window;
var win_browser_default = win;
export {
  win_browser_default as default
};
